import { market } from '../constants';

export const stateParser = (state) => {
  let finalState = {};
  Object.keys(state).map((key) => {
    if (key !== 'logonId') {
      finalState[key] = state[key].value;
    }
  });
  finalState['gender'] = ' ';
  finalState['middleName'] = ' ';
  return finalState;
};

export const getLogonIdToGetOrders = (logonId) => {
  switch (market) {
    case 'pe':
      return logonId;
    case 'cl':
      return logonId.slice(0, -1);
    default:
      return '';
  }
};
